export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_justice-hub-86/artifacts/k61mh56x_Untitled%20design%20%281%29.png";

export const ROTIMI_PORTRAIT =
    "https://customer-assets.emergentagent.com/job_justice-hub-86/artifacts/worg4vzb_Rotimi%20Jacobs%2C%20SAN%2C%20CON..jpg";

export const ROTIMI_LINKEDIN =
    "https://ng.linkedin.com/in/rotimi-jacobs-san-con-83a27110b";

export const HERO_IMG =
    "https://static.prod-images.emergentagent.com/jobs/6e438b4e-bdc7-493d-bac8-8bf62e29a7f8/images/efbb6d4183dffdf84e887d619f4b8f10deff1df43085d472ae620fd44f7cf3a5.png";
export const OFFICE_IMG =
    "https://images.unsplash.com/photo-1646453628191-157ca337a987?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBsYXd5ZXIlMjBvZmZpY2V8ZW58MHx8fHwxNzc4NjAzMzAxfDA&ixlib=rb-4.1.0&q=85";
export const COURTHOUSE_IMG =
    "https://images.unsplash.com/photo-1564596489416-23196d12d85c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxjb3VydGhvdXNlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3ODYwMzMwMHww&ixlib=rb-4.1.0&q=85";
export const SCALES_IMG =
    "https://images.pexels.com/photos/7781900/pexels-photo-7781900.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const ABSTRACT_IMG =
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsYWclMjBvZmZpY2UlMjBuaWdlcmlhfGVufDB8fHx8MTc3ODYwMzMwMHww&ixlib=rb-4.1.0&q=85";
export const CONTRACT_IMG =
    "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBsYXd5ZXIlMjBvZmZpY2V8ZW58MHx8fHwxNzc4NjAzMzAxfDA&ixlib=rb-4.1.0&q=85";

export const PRACTICE_AREAS = [
    {
        slug: "criminal-prosecution",
        title: "Criminal Prosecution",
        kicker: "01",
        short: "White-collar crime, asset tracing and high-profile criminal litigation across all courts.",
        body: "Our firm has prosecuted some of the most consequential criminal cases in Nigerian history — including FRN v. Orji Uzor Kalu, FRN v. Jolly Nyame, FRN v. Joshua Dariye, FRN v. Tafa Balogun and FRN v. Olubukola Saraki. We are the firm of choice for the EFCC, FIRS, CBN and the Federal Ministry of Justice on financial crime matters.",
        image: SCALES_IMG,
    },
    {
        slug: "civil-litigation",
        title: "Civil Litigation",
        kicker: "02",
        short: "Trial advocacy and appellate practice — from the High Court to the Supreme Court of Nigeria.",
        body: "We act for governments, regulators, financial institutions, multinationals and individuals in complex civil litigation, including high-stakes debt recovery, regulatory enforcement and constitutional matters.",
        image: COURTHOUSE_IMG,
    },
    {
        slug: "commercial-litigation",
        title: "Commercial Litigation",
        kicker: "03",
        short: "Counsel to public and private companies, financial institutions and foreign investors.",
        body: "Our commercial litigation practice covers regulatory enforcement, shareholder disputes, contract disputes and general commercial advisory. Clients rely on us for clear, commercially-grounded legal solutions.",
        image: CONTRACT_IMG,
    },
    {
        slug: "arbitration-adr",
        title: "Arbitration & ADR",
        kicker: "04",
        short: "Commercial arbitration practice as counsel, with extensive domestic and international experience.",
        body: "Our partners are members of the Chartered Institute of Arbitrators (UK and Nigeria) with a strong record before institutional and ad hoc tribunals under the Arbitration and Mediation Act, 2023 and major international rules.",
        image: ABSTRACT_IMG,
    },
    {
        slug: "ip-technology",
        title: "Intellectual Property & Technology",
        kicker: "05",
        short: "Trademarks, copyright, technology contracts and digital regulation.",
        body: "From IP registration and enforcement to advising on technology and data protection matters, we help clients secure, exploit and defend the intangible assets that drive modern enterprise.",
        image: OFFICE_IMG,
    },
    {
        slug: "property-real-estate",
        title: "Property & Real Estate",
        kicker: "06",
        short: "Land transactions, title perfection, real estate development and dispute resolution.",
        body: "We act for developers, lenders, individual owners and institutional clients on the full range of real estate matters in Nigeria — from land acquisition and title perfection to complex disputes.",
        image: ABSTRACT_IMG,
    },
];

export const PARTNERS = [
    {
        name: "Rotimi Jacobs, SAN, CON",
        role: "Principal Partner",
        image: "https://customer-assets.emergentagent.com/job_justice-hub-86/artifacts/worg4vzb_Rotimi%20Jacobs%2C%20SAN%2C%20CON..jpg",
        linkedin: "https://ng.linkedin.com/in/rotimi-jacobs-san-con-83a27110b",
        bio:
            "Called to the Nigerian Bar in 1989, Rotimi Jacobs, SAN rose to Head of Gani Fawehinmi Chambers and served on the Editorial Board of the Nigerian Weekly Law Report before founding the firm in 1997. His practice spans financial fraud, regulatory compliance, dispute resolution, litigation, real estate, corporate and general commercial law. He has acted for the Federal Government of Nigeria and for numerous large and medium-sized companies, and has represented the EFCC, FIRS, CBN, the Federal Ministry of Justice and other agencies in high-stakes matters.",
    },
    {
        name: "Adebisi Adeniyi, Esq.",
        role: "Partner",
        image: "https://customer-assets.emergentagent.com/job_justice-hub-86/artifacts/kh2uhi82_Adebisi%20Adeniyi%2C%20Esq.JPG",
        bio:
            "Called to the Bar in 2003, Adebisi Adeniyi is a senior lawyer in the firm with extensive experience prosecuting white-collar crime, asset tracing and banking fraud. He also advises on financial, corporate, dispute resolution, industrial relations, real estate and general commercial law, and has acted for the Federal Government in high-profile matters.",
    },
    {
        name: "Leke Atolagbe, Esq, ACIArb",
        role: "Partner — Head of Abuja Office",
        bio:
            "Called to the Nigerian Bar in 2009, Leke Atolagbe joined Rotimi Jacobs & Co. in 2012 and holds an LL.M from the University of Lagos. His practice includes white-collar crime, asset tracing, secured credit transactions, debt recovery, industrial relations, real estate, arbitration and general commercial law. In 2018 he was admitted as an Assistant to Counsel at the International Criminal Court and is a Notary Public and Associate of the Chartered Institute of Arbitrators (UK).",
    },
];

export const ADMINISTRATIVE_STAFF = [
    {
        name: "Abubakar Sillah",
        role: "Executive Assistant to Principal Head & Office Manager",
    },
    {
        name: "Abdulrahman O. Ayantayo",
        role: "Head, Litigation Department (Lagos)",
    },
    {
        name: "Matthew Adesegun",
        role: "Litigation Officer",
    },
    {
        name: "Caleb Peter",
        role: "Head, Litigation Department (Abuja)",
    },
    {
        name: "Omotoyosi Oladimeji",
        role: "Secretary",
    },
    {
        name: "Ebunoluwa Odelade",
        role: "Secretary",
    },
    {
        name: "Oluwafunmilayo Gbadebo",
        role: "Receptionist",
    },
];

export const ASSOCIATES = [
    {
        name: "Solomon Obafemi, Esq.",
        role: "Senior Associate",
        image: "https://customer-assets.emergentagent.com/job_justice-hub-86/artifacts/uqayorjl_Solomon%20Obafemi%2C%20Esq..JPG",
        bio: "Called to the Nigerian Bar in 2008, Solomon Obafemi worked with Cheakley Chambers before joining Rotimi Jacobs & Co in 2018. His practice covers debt recovery, arbitration, corporate affairs, labour law, land/property regulation, civil litigation and criminal litigation.",
    },
    {
        name: "Oluwaseun Omodele-Balogun, Esq.",
        role: "Associate",
        image: "https://customer-assets.emergentagent.com/job_justice-hub-86/artifacts/ttbsylz3_Oluwaseun%20Omodele-Balogun%2C%20Esq..JPG",
        bio: "Called to the Nigerian Bar in 2015, Oluwaseun Omodele-Balogun served as President and Litigation Chair of the Kwara State Legal Aid Group, representing indigent clients in prison matters. Her practice covers regulatory compliance, economic and financial crimes, civil and criminal litigation, environmental law, corporate governance and commercial transactions.",
    },
    {
        name: "James O. Shaba, Esq.",
        role: "Associate",
        bio: "Called to the Nigerian Bar in 2021, James Oluwaseyi Shaba joined Rotimi Jacobs & Co in 2023. An Associate Member of the Institute of Chartered Mediators and Conciliators, his practice encompasses white-collar crime, corporate practice, civil litigation, real estate, land matters and general commercial law.",
    },
    {
        name: "Michael O. Alaka, Esq.",
        role: "Associate",
        bio: "Called to the Nigerian Bar in 2025, Michael Olusegun Alaka joined Rotimi Jacobs & Co that same year. His practice encompasses dispute resolution, intellectual property, business structuring and property law. He is an AICMC Associate Mediator and member of the International Law Association (Nigerian Chapter).",
    },
];

export const MAJOR_CASES = [
    "FRN v. Orji Uzor Kalu",
    "FRN v. Jolly Nyame",
    "FRN v. Joshua Dariye",
    "FRN v. Tafa Balogun",
    "FRN v. DSP Alamieseigha",
    "FRN v. Lucky Igbinedion",
    "FRN v. Alex Badeh",
    "FRN v. Olubukola Saraki",
    "FGN v. AG, Delta State",
    "Union Bank v. Gitto Construzioni Generali (₦7.8B)",
    "FRN v. Olajide Omokore ($1.6B)",
    "FRN v. M. S. Dasuki (₦33B)",
    "FRN v. Murtala Nyako (₦29B)",
    "FRN v. Raymond Dokpesi (₦2.2B)",
    "FRN v. Stephen Oronsaye (₦2B)",
    "FRN v. Bashir Yuguda (₦19B)",
];

export const TESTIMONIALS = [
    {
        quote:
            "Rotimi Jacobs & Co brings a level of preparation and courtroom command that is exceedingly rare. Our most sensitive matters are in trusted hands.",
        attribution: "General Counsel, Federal Agency",
    },
    {
        quote:
            "Their combination of academic rigour and trial-floor pragmatism delivered an outcome no other firm could have secured.",
        attribution: "CFO, Tier-1 Nigerian Bank",
    },
    {
        quote:
            "When the stakes are existential, this is the firm we call. Their record speaks for itself.",
        attribution: "Managing Partner, International Law Firm",
    },
];

export const OFFICES = {
    head: {
        label: "Head Office — Lagos",
        lines: [
            "Glorious House",
            "2nd & 3rd Floors",
            "50, Queen Street",
            "Alagomeji, Yaba",
            "Lagos.",
        ],
        mapQuery: "50 Queen St, Lagos Mainland, Lagos 101245, Nigeria",
    },
    abuja: {
        label: "Abuja Office",
        lines: [
            "Trinity House",
            "3rd Floor",
            "Plot 943, Cadastral Zone B06",
            "Mabushi",
            "FCT, Abuja.",
        ],
        mapQuery: "Plot 943, Cadastral Zone B06, Mabushi, Abuja, Nigeria",
    },
};

export const PHONES = ["0911 083 4432", "0802 312 4852", "0803 830 1221"];
export const FIRM_EMAIL = "rotimijacobs.law@gmail.com";
export const WEBMAIL_EXTERNAL = "https://mail.google.com";
